import { render, staticRenderFns } from "./OsSubMenuPage.vue?vue&type=template&id=521c01ef&scoped=true"
import script from "./OsSubMenuPage.vue?vue&type=script&lang=ts"
export * from "./OsSubMenuPage.vue?vue&type=script&lang=ts"
import style0 from "./OsSubMenuPage.vue?vue&type=style&index=0&id=521c01ef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521c01ef",
  null
  
)

export default component.exports